import { render, staticRenderFns } from "./FormElementSelectionModal.vue?vue&type=template&id=634dc14c&scoped=true"
import script from "./FormElementSelectionModal.vue?vue&type=script&lang=js"
export * from "./FormElementSelectionModal.vue?vue&type=script&lang=js"
import style0 from "./FormElementSelectionModal.vue?vue&type=style&index=0&id=634dc14c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634dc14c",
  null
  
)

export default component.exports